export const styles = {
  statusColors: {
    RUNNING: '#2196F3',
    COMPLETED: '#4CAF50',
    FAILED: '#F44336',
    DEFAULT: '#9E9E9E',
  },
  filterBoxContainer: {
    display: 'flex',
    gap: 2,
    marginBottom: 2,
    flexWrap: 'wrap',
  },
  filterContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '1em',
    padding: '1em 0',
  },
  select: {
    minWidth: '150px',
  },
  button: {
    fontSize: '0.9rem',
    borderRadius: '1.5em',
    padding: '0.5em 1.5em',
    textTransform: 'none',
  },
  tableContainer: {
    marginTop: '1em',
    borderRadius: '8px',
    overflow: 'hidden',
  },
  tableHeader: {
    fontWeight: 'bold',
    backgroundColor: (theme) => theme.palette.grey[200],
  },
  tableRow: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f0f8ff',
    },
    textDecoration: 'none',
    color: 'inherit',
  },
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
    padding: 2,
  },
  eventTableLoadingContainer: {
    marginTop: 2,
  },
  spinner: {
    color: '#007bff',
    width: '24px',
    height: '24px',
  },
  loadingText: {
    fontSize: '1.2rem',
  },
  errorContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  errorIcon: {
    fontSize: '3rem',
    color: 'red',
    marginBottom: '0.5em',
  },
  errorText: {
    fontSize: '1.2rem',
    fontWeight: 'bold',
    color: 'red',
  },
  sourceUrlLabel: {
    fontWeight: 'bold',
  },
  sourceUrlLink: {
    color: '#1a73e8',
    textDecoration: 'none',
    fontSize: '16px',
    wordBreak: 'break-word',
  },
  sourceSection: {
    padding: '8px',
    backgroundColor: '#f9f9f9',
    border: '1px solid #ddd',
    borderRadius: '4px',
    marginBottom: '16px',
  },
  dropZoneContainer: {
    display: 'grid',
    gap: 4,
    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
  },
  dropZoneBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  fileUploadLabel: {
    display: 'block',
    marginTop: '16px',
  },
  fileUploadButton: {
    padding: '10px 20px',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '16px',
  },
  submitButton: {
    padding: '10px 20px',
    backgroundColor: '#28a745',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '16px',
  },
  divider: {
    margin: '32px 0',
    border: 'none',
    borderTop: '1px solid #ccc',
  },
  preStyle: `
    div[style] pre {
      white-space: pre-wrap;
      word-wrap: break-word;
      overflow-wrap: break-word;
    }
  `,
  idLabel: {
    color: '#007bff',
    fontWeight: 'bold',
  },
  statusLabel: {
    fontWeight: 'bold',
  },
  sourceLabel: {
    maxWidth: '100px',
    wordWrap: 'break-word',
    whiteSpace: 'normal',
  },
  submitContainer: {
    marginTop: '16px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  tableCellFilename: {
    maxWidth: '200px',
    wordWrap: 'break-word',
    whiteSpace: 'normal',
  },
  messageLabel: {
    whiteSpace: 'break-spaces',
  },
};
